<section style="display: flex; align-items: center; height: 100vh;">
    <div nz-col nzSpan="6" nzOffset="9">
        <div class="" style="text-align: center; margin-bottom: 1rem;">
            <div>
                <img src="../../../../assets/Logo.svg" alt="logo" />
            </div>
            <div>
                <small class="color_text_light">Empowering Businesses with Intelligent Applications</small>
            </div>
        </div>
        <div>
            <div style="text-align: center;">
                <h3 class="m-0" style="font-size: 20px;">Login</h3>
            <nz-divider class="my-1"></nz-divider>
            </div>
            <div class="mt-4">
                <form nz-form [formGroup]="validateForm" class="login-form" (ngSubmit)="submitForm()">
                    <nz-form-item class="mb-4">
                      <nz-form-control nzErrorTip="Please input your username!" class="w-100">
                        <nz-input-group nzPrefixIcon="user" class="color_primary_blue">
                          <input type="text" nz-input formControlName="username" placeholder="Username" />
                        </nz-input-group>
                      </nz-form-control>
                    </nz-form-item>
                    <nz-form-item>
                      <nz-form-control nzErrorTip="Please input your Password!" class="w-100">
                        <nz-input-group nzPrefixIcon="lock" class="color_primary_blue">
                          <input type="password" nz-input formControlName="password" placeholder="Password" />
                        </nz-input-group>
                      </nz-form-control>
                    </nz-form-item>
                    <div nz-row class="login-form-margin" class="mt-4 mb-4">
                      <div nz-col [nzSpan]="12">
                        <label nz-checkbox formControlName="remember">
                          <span>Remember me</span>
                        </label>
                      </div>
                      <div nz-col [nzSpan]="12">
                        <a class="login-form-forgot">Forgot Your password</a>
                      </div>
                    </div>
                    <button nz-button class="login-form-button login-form-margin" [nzType]="'primary'">Log in</button>
                  </form>
            </div>
        </div>
    </div>
</section>